import {FC} from 'react'
import {RemovedProduct} from '../core/_models'
import {Badge} from 'react-bootstrap'
import {useIntl} from 'react-intl'

type IProps = {
  product: RemovedProduct
  onImageClick: (imageUrl: string) => void
}

const RemovedProductsTableRow: FC<IProps> = ({product, onImageClick}) => {
  const {formatMessage} = useIntl()

  return (
    <tr>
      <td>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-75px me-5'>
            <img
              src={product.image || '/media/stock/ecommerce/1.gif'}
              alt={product.product_name || 'Product'}
              onClick={() => onImageClick(product.big_image || product.image || '')}
              style={{cursor: 'pointer'}}
              className='symbol-label'
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.src = '/media/stock/ecommerce/1.gif'
              }}
            />
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder fs-6'>
              {product.product_name || '-'}
            </span>
          </div>
        </div>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.barcode || '-'}
        </span>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.model || '-'}
        </span>
      </td>
      <td className='text-center'>
        <span className='text-dark fw-bold d-block fs-7'>
          {product.quantity || 0}
        </span>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.removal_reason || '-'}
        </span>
      </td>
      <td>
        <span className='text-dark fw-bold d-block fs-7'>
          #{product.po_id || '-'}
        </span>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.removed_date ? new Date(product.removed_date).toLocaleDateString() : '-'}
        </span>
      </td>
      <td className='text-center'>
        <Badge
          bg={product.confirmation_status === 'confirmed' ? 'success' : 'warning'}
          className='px-3 py-2'
        >
          {formatMessage({
            id: `REMOVED_PRODUCTS.STATUS.${product.confirmation_status?.toUpperCase() || 'PENDING'}`,
          })}
        </Badge>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.confirmed_by_name || '-'}
        </span>
      </td>
      <td>
        <span className='text-muted fw-bold d-block fs-7'>
          {product.supplier_confirmed_date
            ? new Date(product.supplier_confirmed_date).toLocaleString()
            : '-'}
        </span>
      </td>
    </tr>
  )
}

export default RemovedProductsTableRow

